import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IndicadoresProjetoService } from '../../services/indicadores-projeto.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-indicadores-entregas-relacionadas-edit',
  templateUrl: './detalhe-projeto-indicadores-entregas-relacionadas-edit.component.html',
  styleUrls: ['./detalhe-projeto-indicadores-entregas-relacionadas-edit.component.scss']
})
export class DetalheProjetoIndicadoresEntregasRelacionadasEditComponent extends BaseFormComponent<IndicadoresProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  entregasList: any[];

  constructor(private myService: IndicadoresProjetoService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initList();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    this.addSub(
      this.myService.getListEntregasRelacionados(this.entity?.id).subscribe({
        next: (res) => {
          this.entregasList = res;
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    )
  }

  voltar() {
    if (this.entity?.id) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores', this.entity?.id]);
    } else {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores']);
    }
  }

}
